export default class OhsResourceCentreFilterModels {
  viewPreset: 'view_1' | 'view_2';

  sort: string;

  archive: boolean;

  tableSortKeyLists: {
    sortColAscDescOptions: { name: string; value: string }[];
  };

  constructor() {
    this.viewPreset = 'view_1';
    this.sort = '{ "key": "_id", "order": 1 }';
    this.archive = false;
    this.tableSortKeyLists = {
      sortColAscDescOptions: [
        { name: 'Created Order: Newest to Oldest', value: '{ "key": "_id", "order": -1 }' },
        { name: 'Created Order: Oldest to Newest ', value: '{ "key": "_id", "order": 1 }' },
      ],
    };
  }
}
